import { dm_ket_qua_lien_he } from "../models/response/category/dm_ket_qua_lien_he";
import { apiClient } from "./apiClient";

export const KET_QUA_LIEN_HE_API_END_POINT = "ket-qua-lien-he";

export const ketQuaLienHeApi = {
    select_by_coso: (dm_coso_id: number) => apiClient.get(`${KET_QUA_LIEN_HE_API_END_POINT}?dm_coso_id=${dm_coso_id}`),
    detail: (id: number) => apiClient.get(`${KET_QUA_LIEN_HE_API_END_POINT}/${id}`),
    insert: (payload: dm_ket_qua_lien_he) => apiClient.post(KET_QUA_LIEN_HE_API_END_POINT, payload),
    update: (payload: dm_ket_qua_lien_he) => apiClient.put(KET_QUA_LIEN_HE_API_END_POINT, payload),
    delete: (id: number) => apiClient.delete(`${KET_QUA_LIEN_HE_API_END_POINT}/${id}`)
}
